// extracted by mini-css-extract-plugin
export var downArrow = "_js-0";
export var infoTooltipIcon = "_js-3";
export var label = "_js-1";
export var optionCard = "_js-4";
export var upArrow = "_js-2";